import React from 'react';

import {
    Box,
    Grid,
    Paper,
    Stack,
    Typography,
} from '@mui/material';

import { lightBlue, blueGrey } from '@mui/material/colors';

import { motion } from 'framer-motion';
// Framer Motion 애니메이션 Variants
const cardVariants = {
    hidden: { y: 50, opacity: 0 },
    visible: { 
        y: 0, 
        opacity: 1,
        transition: { duration: 0.6, ease: "easeOut" }
    }
};

// 이미지 애니메이션 Variants
const imageLeftVariant = {
    rest: { x: 0 },
    hover: { x: "15%" } // 오른쪽으로 50% 이동
};

const imageRightVariant = {
    rest: { x: 0 },
    hover: { x: "-15%" } // 왼쪽으로 50% 이동
};

export default function CleaningCartCard(props){

    const link = "/products/cleaningcart";
    return (
        <Grid size={{
            xs : 12,
            sm : 6,
            md : 6
            }}>
            <Paper
                className="da-box-shadow"
                elevation={2}
                sx={{position:'relative', width:'100%', paddingBottom:'60%', borderRadius:'16px', backgroundColor:lightBlue[900]}}>
                <Box
                    component="a"
                    href={link}
                    sx={{ textDecoration: 'none' }}>
                <Box
                    sx={{posiiton:'absolute', width:'100%', height:'100%'}}
                    component={motion.div}
                    initial="rest"
                    whileHover="hover"
                    animate="rest">
                    {/* 왼쪽 이미지 */}
                    <Box
                        component={motion.div}
                        variants={imageLeftVariant}
                        transition={{ duration: 0.4, ease: 'easeInOut' }}
                        sx={{ position: 'absolute', left: 0, top: 0, width: '50%', height: '100%' }}
                      >
                        <img src={"/assets/images/type_cart.png"} alt={`${"cleaning cart"} 1`} style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                      </Box>
                      {/* 오른쪽 이미지 */}
                      <Box
                        component={motion.div}
                        variants={imageRightVariant}
                        transition={{ duration: 0.4, ease: 'easeInOut' }}
                        sx={{ position: 'absolute', right: 0, top: 0, width: '50%', height: '100%' }}
                      >
                        <img src={"/assets/images/type_wagon.png"} alt={`${"cleaning cart"} 2`} style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                      </Box>
                    <Box
                        sx={{
                        position:'absolute', width:'100%', height:'100%', borderRadius:'16px',
                        background:'linear-gradient(180deg, rgba(0,0,0,0), rgba(0,0,0,200))'
                        }}>
                    </Box>
                </Box>
                
                <Stack
                sx={{position:'absolute', bottom:'24px', left:'24px'}}
                direction="column"
                className="da-button-arrow"
                justifyContent="flex-start"
                alignItems="flex-start"
                component={motion.div}
                variants={cardVariants}
                // ✅ 카드 전체에 대한 호버 효과는 미세하게 조정 (살짝 위로)
                whileHover={{ y: -5 }}
                transition={{ duration: 0.3 }}
                spacing={.5}>
                <Typography
                    sx={{
                    fontFamily: "NotoSansKR",
                    fontWeight:700,
                    fontSize:'15px',
                    textAlign:'left',
                    color:'#ddd'
                    }}>
                    제품 출시
                </Typography>
                <Typography
                    sx={{
                    fontFamily: "NotoSansKR",
                    fontWeight:900,
                    fontSize:'24px',
                    textAlign:'left',
                    color:'#ffffff'
                    }}>
                    Daclair 청소카트
                </Typography>
                <Typography
                    sx={{
                    fontFamily: "NotoSansKR",
                    fontWeight:500,
                    fontSize:'16px',
                    textAlign:'left',
                    color:'#ffffff'
                    }}>
                    편리하고 환경을 생각한 청소카트를 만나보세요
                </Typography>
                </Stack>
                </Box>
            </Paper>
        </Grid>
    );
}